/**
 * 絞り込む
 * @param {object} selectedStack - 絞り込み条件
 * @param {object} articleData - 絞り込む記事データ
 * @returns {object} - 絞り込み条件に合致した記事データ
 *
 * 絞り込みデータの形式
 * {
 *    '職種':{cat-id: cat-id, 1: 1, number: number},   ←この中でOR検索
 *    '入社時期':{cat-id: cat-id, 2: 2, number: number}, --- OR検索を縦に積むとAND検索
 *    '採用区分':{cat-id: cat-id, 3: 3, number: number}, -┘
 * }
 */
const searchArticles = (selectedStack, articleData) => {

  // console.log(`selectedStack(選択したカテゴリ)`);
  // console.log(selectedStack);

  let searchItemKeys = Object.keys(selectedStack);
  let articleKeys = Object.keys(articleData);

  // ベースケース
  if(searchItemKeys.length == 0) return articleData;

  let iterator = selectedStack[searchItemKeys[0]];
  let iteratorKeys = Object.keys(iterator);


  // selectedStackをpop
  delete selectedStack[searchItemKeys[0]];
  let newSelectedStack = {...selectedStack};

  // 選択がなければ『全て』を選択したという事で全ての記事を返す
  if(iteratorKeys.length == 0) return searchArticles(newSelectedStack, articleData);

  let newArticleData = {};

  articleKeys.map((key) => {
    // console.log(`filter key:${key}`)
    // 重複があるかチェック
    // 1. それぞれのkeyの数を足す。
    // 2. Set関数で重複を排除する
    // 3. 1と2の数を比較し、2の数の方が小さければ重複があったという事となる
    let articleCatsKeys = Object.keys(articleData[key].categorys);

    let sum = iteratorKeys.length + articleCatsKeys.length;
    let arr = new Set(iteratorKeys.concat(articleCatsKeys));

    // 重複があればtrue 重複がなければfalse
    if(sum > arr.size) {
      newArticleData[key] = {...articleData[key]};
    }
  });

  return searchArticles(newSelectedStack, newArticleData);
};

export default searchArticles;